export default {
 "columns": 12,
 "image": "shrine-background-tiles.png",
 "imageheight": 96,
 "imagewidth": 192,
 "margin": 0,
 "name": "shrine-backgroune-tiles",
 "spacing": 0,
 "tilecount": 72,
 "tiledversion": "1.11.0",
 "tileheight": 16,
 "tilewidth": 16,
 "type": "tileset",
 "version": "1.10",
 "tiles": [
  {
   "id": 0,
   "type": "decal"
  },
  {
   "id": 1,
   "type": "decal"
  },
  {
   "id": 2,
   "type": "decal"
  },
  {
   "id": 3,
   "type": "decal"
  },
  {
   "id": 4,
   "type": "decal"
  },
  {
   "id": 5,
   "type": "decal"
  },
  {
   "id": 6,
   "type": "decal"
  },
  {
   "id": 7,
   "type": "decal"
  },
  {
   "id": 8,
   "type": "decal"
  },
  {
   "id": 9,
   "type": "decal"
  },
  {
   "id": 10,
   "type": "decal"
  },
  {
   "id": 11,
   "type": "decal"
  },
  {
   "id": 12,
   "type": "decal"
  },
  {
   "id": 13,
   "type": "decal"
  },
  {
   "id": 14,
   "type": "decal"
  },
  {
   "id": 15,
   "type": "decal"
  },
  {
   "id": 16,
   "type": "decal"
  },
  {
   "id": 17,
   "type": "decal"
  },
  {
   "id": 18,
   "type": "decal"
  },
  {
   "id": 19,
   "type": "decal"
  },
  {
   "id": 20,
   "type": "decal"
  },
  {
   "id": 21,
   "type": "decal"
  },
  {
   "id": 22,
   "type": "decal"
  },
  {
   "id": 23,
   "type": "decal"
  },
  {
   "id": 24,
   "type": "decal"
  },
  {
   "id": 25,
   "type": "decal"
  },
  {
   "id": 26,
   "type": "decal"
  },
  {
   "id": 27,
   "type": "decal"
  },
  {
   "id": 28,
   "type": "decal"
  },
  {
   "id": 29,
   "type": "decal"
  },
  {
   "id": 30,
   "type": "decal"
  },
  {
   "id": 31,
   "type": "decal"
  },
  {
   "id": 32,
   "type": "decal"
  },
  {
   "id": 33,
   "type": "decal"
  },
  {
   "id": 34,
   "type": "decal"
  },
  {
   "id": 35,
   "type": "decal"
  },
  {
   "id": 36,
   "type": "decal"
  },
  {
   "id": 37,
   "type": "decal"
  },
  {
   "id": 38,
   "type": "decal"
  },
  {
   "id": 39,
   "type": "decal"
  },
  {
   "id": 40,
   "type": "decal"
  },
  {
   "id": 41,
   "type": "decal"
  },
  {
   "id": 42,
   "type": "decal"
  },
  {
   "id": 43,
   "type": "decal"
  },
  {
   "id": 44,
   "type": "decal"
  },
  {
   "id": 45,
   "type": "decal"
  },
  {
   "id": 46,
   "type": "decal"
  },
  {
   "id": 47,
   "type": "decal"
  },
  {
   "id": 48,
   "type": "decal"
  },
  {
   "id": 49,
   "type": "decal"
  },
  {
   "id": 50,
   "type": "decal"
  },
  {
   "id": 51,
   "type": "decal"
  },
  {
   "id": 52,
   "type": "decal"
  },
  {
   "id": 53,
   "type": "decal"
  },
  {
   "id": 60,
   "type": "decal"
  },
  {
   "id": 61,
   "type": "decal"
  },
  {
   "id": 62,
   "type": "decal"
  },
  {
   "id": 63,
   "type": "decal"
  },
  {
   "id": 64,
   "type": "decal"
  },
  {
   "id": 65,
   "type": "decal"
  }
 ]
};